<template>
  <div class="p-1">
    <Fieldset
      class="p-0"
    >
      <template #legend>
        <input
          id="enableday"
          type="checkbox"
          :checked="modelValue != null"
          class="mr-2"
          @change="toggleEnable"
        >
        <label for="enableday">{{ title }}</label>
      </template>

      <div v-if="modelValue != null">
        <p class="font-bold">
          {{ $t('entity.planning.morning') }}
        </p>
        <div class="col-12 p-0">
          <label for="openMorning">{{ $t('entity.planning.from') }}</label>
          <Calendar
            id="openMorning"
            :model-value="formattedData.morningOpen"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('morningOpen', value)"
          />
          <label for="closeMorning">{{ $t('entity.planning.to') }}</label>
          <Calendar
            id="closeMorning"
            :model-value="formattedData.morningClose"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('morningClose', value)"
          />
        </div>

        <Divider />
        <p class="font-bold">
          {{ $t('entity.planning.afternoon') }}
        </p>
        <div class="col-12 p-0">
          <label for="openAfternoon">{{ $t('entity.planning.from') }}</label>
          <Calendar
            id="openAfternoon"
            :model-value="formattedData.afternoonOpen"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('afternoonOpen', value)"
          />
          <label for="closeAfternoon">{{ $t('entity.planning.to') }}</label>
          <Calendar
            id="closeAfternoon"
            :model-value="formattedData.afternoonClose"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('afternoonClose', value)"
          />
        </div>
      </div>
    </Fieldset>
  </div>
</template>

<script>
import Fieldset from 'primevue/fieldset'
import Divider from "primevue/divider";
import Calendar from "primevue/calendar";
import moment from "moment";

const DEFAULT_DAY = {
  morningOpen:'08:00:00',
  morningClose: '12:00:00',
  afternoonOpen: '14:00:00',
  afternoonClose: '18:00:00'
}

export default {
  name: 'DayPlanningForm',
  components: {Calendar, Fieldset, Divider},
  props: {
    title: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    formattedData(){
      return {
        morningOpen: moment(this.modelValue.morningOpen, 'HH:mm:ss').toDate(),
        morningClose: moment(this.modelValue.morningClose, 'HH:mm:ss').toDate(),
        afternoonOpen: moment(this.modelValue.afternoonOpen, 'HH:mm:ss').toDate(),
        afternoonClose: moment(this.modelValue.afternoonClose, 'HH:mm:ss').toDate(),
      }
    }
  },
  methods: {
    toggleEnable() {
      this.$emit('update:modelValue', this.modelValue ? null : DEFAULT_DAY)
    },

    update(field, value){
      let data = {...this.formattedData}
      data[field] = value
      data.morningOpen = moment(data.morningOpen).format('HH:mm:ss')
      data.morningClose = moment(data.morningClose).format('HH:mm:ss')
      data.afternoonOpen = moment(data.afternoonOpen).format('HH:mm:ss')
      data.afternoonClose = moment(data.afternoonClose).format('HH:mm:ss')
      this.$emit('update:modelValue', data)
    }
  }
}
</script>
